<template>
    <v-dialog
      v-model="dialog"
      max-width="800"
    >

      <v-card>
        <div class="py-8"></div>
        <v-card-text v-html="content">
        </v-card-text>
      </v-card>
    </v-dialog>
</template>


<script>
  export default {
    name: 'LegalDialog',
    data: () => ({
      dialog: false,
      content_loaded: false,
      content: "Loading....",
    }),
    methods: {
      openDialog() {
        this.dialog = true;
        if (!this.content_loaded) {
            this.$http
                .get(this.getHost() + 'content/legal.html')
                .then(function(data) {
                    this.content = data.body;
                });
                this.content_loaded = true;
         }
      }
    },
    watch: {
    }
  }
</script>
